import { ADMIN_ID, OWNER_LABEL } from '@app/constants';

import type { BaseOptionType } from 'antd/es/select';

export const USER_ID = 'user';
export const DELETED_ID = 'deleted';

export const USER_LABEL = 'Пользователь';
export const DELETED_LABEL = 'В архиве';

export const STATUSES: BaseOptionType[] = [
  {
    value: ADMIN_ID,
    label: <span data-testid="owner-status">{OWNER_LABEL}</span>,
    filterName: OWNER_LABEL,
  },
  {
    value: USER_ID,
    label: <span data-testid="user-status">{USER_LABEL}</span>,
    filterName: USER_LABEL,
  },
  {
    value: DELETED_ID,
    label: <span data-testid="in-archive-status">{DELETED_LABEL}</span>,
    filterName: DELETED_LABEL,
  },
];
